import type * as api from '@gitbook/api-client';

import type { ShareableContent } from './types';

/**
 * Whether the current user can manage sharing for a piece of shareable content (space or collection).
 * Content admins who are guests in the organization are intentionally excluded because the share
 * dialog exposes organization-level members, teams, and invite-link settings.
 */
export function canManageContentSharing(
    content: ShareableContent,
    organization: api.Organization
): boolean {
    const isContentAdmin =
        'space' in content ? content.space.permissions.admin : content.collection.permissions.admin;

    return isContentAdmin && organization.permissions.listInstallations;
}
